var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallPick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#17930f",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    "data-originalfillcolor": "#000000",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.3,374.7c-8.2-16.9-18.8-29.2-37.1-21.7l-36.1,13.4c-28.9,13.4-43.3,0-57.7-20.1l-64.9-147.8 c-8.1-16.9-3.9-32.8,14.4-40.3l50.5-20.1c18.3-7.5,15.4-23.4,7.2-40.3l-43.3-80.6c-8.2-16.9-25-21-43.3-13.5 C64.4,18.9,34.1,42.5,14.5,77.6c-24,42.9-12,102.5-7.2,127.6c4.8,25.1,21.6,69,43.3,114.2c21.7,45.2,40.7,80.7,57.7,100.8 c17,20.1,57.7,75.1,108.2,87.3c41.4,10,86,1.6,122.6-13.5c18.3-7.5,18.4-23.4,10.2-40.4L311.3,374.7z M413.5,118.1h-59.1l78.8,78.8 H256v39.4h177.2L354.5,315h59.1l98.5-98.5L413.5,118.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallPick);
export default __webpack_public_path__ + "static/media/call_pick.cf9317ee4fbe180131460a2b1f6111b2.svg";
export { ForwardRef as ReactComponent };